import { render, staticRenderFns } from "./AddEditDevices.vue?vue&type=template&id=37539920"
import script from "./AddEditDevices.vue?vue&type=script&lang=js"
export * from "./AddEditDevices.vue?vue&type=script&lang=js"
import style0 from "./AddEditDevices.vue?vue&type=style&index=0&id=37539920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports